import React from 'react';
import { ChevronRight } from 'lucide-react';

const STEPS = [
  {
    step: 1,
    text: 'Выберите лицензию и добавьте её в корзину',
  },
  {
    step: 2,
    text: 'Перейдите на страницу оформления заказа',
  },
  {
    step: 3,
    text: 'Введите данные компании и оформите заказ',
  },
  {
    step: 4,
    text: 'Получите счет',
  },
];

const InvoiceStepsSection = () => {
  return (
    <section className="py-16 bg-background" aria-labelledby="invoice-steps-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 md:mb-12">
          <h2
            id="invoice-steps-heading"
            className="text-3xl md:text-4xl font-bold text-foreground"
          >
            Как оформить заказ
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row items-stretch justify-start gap-6 lg:gap-0">
          {STEPS.map((item, index) => (
            <React.Fragment key={item.step}>
              <div className="w-full max-w-sm lg:max-w-none lg:flex-1 flex flex-col min-w-0">
                <div className="flex-1 flex flex-col items-start text-left bg-white rounded-xl border border-border/50 p-6 md:p-8 shadow-lg transition-all duration-300 hover:border-accent/50 hover:shadow-lg hover:shadow-accent/5">
                  <div
                    className="w-20 h-20 md:w-[5.5rem] md:h-[5.5rem] rounded-full border-2 border-accent bg-accent/10 flex items-center justify-center mb-5 md:mb-6 flex-shrink-0"
                    aria-hidden
                  >
                    <span className="text-base md:text-lg font-bold text-foreground leading-tight">
                      {item.step} шаг
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-muted-foreground leading-snug">
                    {item.text}
                  </p>
                </div>
              </div>

              {index < STEPS.length - 1 && (
                <div
                  className="hidden lg:flex items-center justify-center flex-shrink-0 px-2 xl:px-3 self-center text-accent"
                  aria-hidden
                >
                  <ChevronRight className="w-6 h-6 stroke-[2]" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InvoiceStepsSection;
